import { Component, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SelectionState } from '@alfresco/adf-extensions';
import { AppStore, getAppSelection } from '@alfresco/aca-shared/store';
import { SmtDownloadAllAction } from 'projects/alden-extension/src/lib/store/actions/actions';

@Component({
  selector: 'alden-download-all',
  templateUrl: './download-all.component.html'
})
export class DownloadAllComponent implements OnInit {

  selection$: Observable<SelectionState>;

  constructor(private store: Store<AppStore>) {}

  ngOnInit() {
    this.selection$ = this.store.select(getAppSelection);
  }

  download(selection: SelectionState) {
    this.store.dispatch(new SmtDownloadAllAction(selection));
  }


}
